<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px"
        :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="考试类型">

              <select-option-dictionary @change="chgType()" v-model="formParameter.type"
                dkey="exam-type"></select-option-dictionary>

            </el-form-item>
          </el-col>
          <el-col :span="12">

            <el-form-item :label="formParameter.type == 2 || formParameter.type == 4 ? '面试题数' : '多选属性'" prop="canScore">
              <el-input v-if="formParameter.type == 2 || formParameter.type == 4" v-model="formParameter.quenum"
                autocomplete="off"></el-input>
              <el-select v-else v-model="formParameter.canScore">
                <el-option v-for="item in [{ id: 0, name: '多选漏选给半分' }, { id: 1, name: '多选漏选不给分' }]" :key="item.id"
                  :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="考试班级" prop="cid">

              <el-select v-if="formParameter.type == 1 || formParameter.type == 5 || formParameter.type == 6"
                v-model="clzIdx" :clearable="true" :filterable="true" placeholder="请选择班级1/可搜索" @change="chgClzz()">
                <el-option v-for="(v, i) in listClass" :key="v.name" :label="v.name" :value="i">
                </el-option>
              </el-select>

              <el-select v-else multiple v-model="clzIdxes" :clearable="true" :filterable="true"
                placeholder="请选择班级2/可搜索" @change="chgClzzes()">
                <el-option v-for="(v, i) in listClass" :key="v.id" :label="v.name" :value="i">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考试名称" prop="name">
              <el-input v-model="stuExamName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-for="(item, index) in selectedClz" :key="item.name">

          <el-col :span="20">
            <el-form-item :label="item.name" prop="sid">

              <el-select v-if="formParameter.type == 6" v-model="selectedStu[index]" :clearable="true"
                :filterable="true" multiple placeholder="请选择学生" @visible-change="chgStudent" @change="chgStu()">
                <el-option v-for="v in listStu[index]" :key="v.id" :label="v.name" :value="v.id">
                </el-option>
              </el-select>
              <el-select v-else v-model="selectedStu[index]" :clearable="true" :filterable="true" multiple
                placeholder="请选择学生" @visible-change="chgStudent" @change="chgStu()">
                <el-option v-for="v in listStu[index]" :key="v.id" :label="v.name" :value="v.name">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-checkbox v-model="item.checked" @change="selectAll(index)">全选</el-checkbox>
          </el-col>
        </el-row>
        <el-row
          v-if="formParameter.type == 0 || formParameter.type == 1 || formParameter.type == 2 || formParameter.type == 3 || formParameter.type == 4">
          <el-col :span="12">
            <el-form-item label="试卷名称" prop="expid" with="">

              <el-select multiple v-if="formParameter.type == 1" v-model="examIds" :clearable="true" placeholder="请选择">
                <el-option v-for="item in listExam" :key="item.id" :label="item.name" :value="item.expid">
                </el-option>
              </el-select>

              <el-autocomplete v-else class="inline-input" v-model="examId" :fetch-suggestions="queryPaper"
                placeholder="请输入内容" @select="selectPaper"></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对应科目" prop="sbname">
              <el-input v-model="sbname" autocomplete="off" disabled placeholder="空"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-else-if="formParameter.type == 6 && clzIdx != ''">
          <el-col :span="12">
            <el-form-item label="模块名称" prop="expid" with="">
              <el-select v-model="selectMoudle" @change="chgMod" :clearable="true" placeholder="请选择">
                <el-option v-for="item in moudleInfo" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对应科目" prop="sbname">
              <el-select v-model="selectSubjectIdx" @change="chgSub" :clearable="true" placeholder="请选择">
                <el-option v-for="(item, idx) in subjectInfo" :key="item.id" :label="item.name" :value="idx">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formParameter.type == 6">
          <div style="margin-bottom: 15px;">
            <el-table :data="stuExamInfo" :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }">
              <el-table-column prop="exampapername" label="试卷名称" width="300px"></el-table-column>
              <el-table-column prop="stringList" label="考试情况" width="300px"></el-table-column>
              <el-table-column label="操作" width="300px">
                <template slot-scope="scope">
                  <el-button @click="genExam(scope.row)">布置考试</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-dialog title="学生选择" :visible.sync="dialogFormVisible" :append-to-body="true" :before-close="cancle">
            <el-form>
              <el-form-item label="学生" prop="selectedNoexStu" label-width="60px">
                <el-select v-model="selectedNoexStu" multiple>
                  <el-option v-for="(v, i) in noexamstu" :key="v" :label="v" :value="v">
                  </el-option>
                </el-select>
              </el-form-item><br>
              <el-form-item label="日期" label-width="60px">
                <el-date-picker v-model="dateTime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button @click="cancle">取 消</el-button>
              <el-button @click="confirm()">布置考试</el-button>
            </div>
          </el-dialog>
        </el-row>

        <el-row v-if="formParameter.type != 6">
          <el-col :span="12">
            <el-form-item label="日期选择">
              <el-date-picker v-model="dateTime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>


        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>

import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/exams/exams/exams.js";
import examApi from "@/api/exams/exampaper/exampaper.js";
import paperApi from '@/api/exams/exampaper/exampaper.js';
import classApi from "@/api/edu/clazz/clazz.js";
import stuapi from "@/api/stus/student/student.js";
import subApi from "@/api/edu/subject/subject.js";
import tree from "@/components/tree/tree.vue";
import couApi from "@/api/edu/course/course.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";


export default {
  name: "edit",
  components: {
    popup,
    tree,
    selectOptionDictionary,
  },
  data() {
    return {
      sbname: "",
      // dialogVisible: false,
      // permissionList: [],

      subData: [], // 专业数据

      listClass: [], // 备选班级
      clzIdxes: [], // 选中的班级序号  多选
      clzIdx: "", // 选中的班级序号  单选
      selectedClz: [], // 选中的班级

      listStu: [], // 备选的学生
      selectedStu: [], // 选中的学生

      examId: "", // 选择的考试
      examIds: [], // 选择的复选考试id
      listExam: [], //试卷
      isMobile: 0, //是不是移动考试
      courseName: [],//课程
      selCourse: [],//选择的课程
      sid: [],//课程下的模块id
      moudleInfo: [],//模块信息
      selectMoudle: [],//选中的模块
      subjectInfo: [],//科目信息
      selectSubjectIdx: "",//选中的科目
      stuExamInfo: [],//列表信息
      stuIds: "",//学生ids
      subId: "",//科目id
      rowlist: "",//试卷名字
      selectedNoexStu: [],//选中未考试的学生
      noexamstu: [],//未考试的学生

      stuExamName: "",
      tomorrow: '',
      dateTime: "",

      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      parameter: {},
      formParameter: {
        examType: 0,
        type: 0,
        canScore: 1,
        sid: "",
        cid: "",
        answer: "",
        type: 1,
        isSubjective: 2,
        reference: "自编题",
      },
      rules: {
        //生效时间
        startTime: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 50,
            trigger: "blur",
          },
        ],
        //截止时间
        endTime: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 50,
            trigger: "blur",
          },
        ]
      },
    };
  },
  methods: {

    queryPaper(queryStr, cb) {
      let param = { name: queryStr };

      examApi.intionlist(param, (res) => {
        this.listExam = res.data;
        // console.log("this.listExam  ===>", this.listExam);
        var results = queryStr
          ? this.listExam.filter(this.createFilter(queryStr))
          : this.listExam;
        // 调用 callback 返回建议列表的数据
        cb(results);
      });
    },
    createFilter(queryStr) {
      return (data) => {
        return data.value.indexOf(queryStr) === 0;
      };
    },
    selectPaper(item) {
      this.formParameter.expid = item.id;

      if (item.isMobile) {
        this.isMobile = item.isMobile;
      } else {
        this.isMobile = 0;
      }

      //根据试卷id查询对应的科目
      subApi.selectNameByKid({ id: item.id }, (res) => {
        if (res.data[0]) {
          this.sbname = res.data[0].name;
          this.formParameter.sbname = res.data[0].name;
        } else {
          this.formParameter.sbname = "";
          this.sbname = "";
        }
      });
    },

    chgType() {

      console.log("formParameter.type = ", this.formParameter.type)

      //reset
      this.examId = "";
      this.examIds = [];
      this.listStu = [];
      this.selectedStu = [];
      this.selectedClz = [];
      this.clzIdxes = [];
      this.clzIdx = "";
      this.listExam = [];

      //强制刷新
      this.$forceUpdate();
    },
    chgClzz() {
      //reset
      this.clzIdxes = [];
      this.selectedClz = [];
      this.listStu = [];
      this.selectedStu = [];
      this.moudleInfo = [];
      this.selectMoudle = [];
      this.selectSubjectIdx = "";
      this.subjectInfo = [];
      this.courseName = [];
      this.selCourse = [];
      this.noexamstu = [];
      this.selectedNoexStu = [];
      this.stuExamName = "";

      let slktClz = this.listClass[this.clzIdx];
      this.selectedClz.push(slktClz);
      if(this.formParameter.type==6){
        slktClz.checked = true;
      }
 

      //考试名称推荐   clzIdxes
      this.stuExamName = this.listClass[this.clzIdx].name + "-" + new Date().format("yyMMdd")

      //是阶段过关考试
      if (this.formParameter.type == 6) {
        this.selCourse = 0
      }


      couApi.getNameById({ cid: slktClz.cid }, response => {
        if (response.msg.length > 0) {
          this.courseName.push(response.data.name);
          this.sid = response.data.sid;

          //是阶段过关考试
          if (this.formParameter.type == 6) {
            this.chgcourse()
          }

        }
      })

      if (this.formParameter.type == 6) {       //是阶段过关考试
        stuapi.stuInClass1({ cid: slktClz.id }, (response) => {
          if (response.data.length > 0) {
            this.listStu.push(response.data);
            this.selectAll(0);
          }
        });
      } else {
        stuapi.stuInClass1({ cid: slktClz.id }, (response) => {
          if (response.data.length > 0) {
            this.listStu.push(response.data);
            //this.selectAll(0);
          }
        });
      }


      //线下考试   加载试卷
      if (this.formParameter.type == 1) {
        api.list(
          { name: this.listClass[this.clzIdx].name, isDropList: true },
          (res) => {
            this.listExam = res.data.records;
            this.$forceUpdate();
          }
        );
      }
    },
    chgClzzes() {

      //reset
      this.clzIdx = "";
      this.selectedClz = [];
      this.listStu = [];

      //考试名称推荐   clzIdxes
      this.stuExamName = "考试-" + new Date().format("yyMMddhhmmss")

      console.log("this.formParameter.type ", this.formParameter.type)

      this.clzIdxes.forEach((v, i) => {
        let clz = this.listClass[v];
        clz.checked = false;
  
        this.selectedClz.push(clz);
        this.listStu.push([])
        stuapi.stuInClass1({ cid: clz.id }, (response) => {
          if (response.data.length > 0) {
            //this.listStu.push(response.data);
            this.listStu[i] = response.data;
            //强制刷新
            this.$forceUpdate();
            
          }
        });
      });


    },
    genExam(row) {
      this.dialogFormVisible = true;
      this.rowlist = row;

      this.formParameter.expid = this.rowlist.id

      for (let i = 0; i < this.listStu[0].length; i++) {

        console.log(this.listStu[0][i].name);
        console.log(this.rowlist.stringList.indexOf(this.listStu[0][i].name));

        if (this.rowlist.stringList.indexOf(this.listStu[0][i].name) == -1)
          this.noexamstu.push(this.listStu[0][i].name);
      }
    },

    chgStu() {
      this.stuIds = this.selectedStu;
      console.log(this.selectedStu + "");


    },
    chgcourse() {
      this.selectMoudle = [];
      this.selectSubjectIdx = "";

      subApi.listsId({ id: this.sid }, (res) => {
        if (res.data[0]) {
          this.moudleInfo = res.data
        }
      });
    },
    chgMod(value) {
      this.selectSubjectIdx = "";
      subApi.selectModelByid({ id: value }, res => {
        if (res.data[0])
          this.subjectInfo = res.data;
      })
    },
    chgSub() {
      this.subId = this.subjectInfo[this.selectSubjectIdx].id;
      if (this.subId != null && this.selectSubjectIdx >= 0)
        this.StuExam();
    },
    chgStudent(visible) {
      if (visible) {
        return;
      }
      if (this.stuIds != "" && this.selectSubjectIdx >= 0) {
        this.StuExam();
      } else {
        this.stuExamInfo = [];
      }

    },
    //查询列表中的数据
    StuExam() {
      subApi.listStuExam(
        {
          id: this.stuIds,
          subjectId: this.subId,
        },
        (res) => {
          this.stuExamInfo = res.data;
        }
      )
    },

    selectAll(index) {
      let s = [];
      if (this.selectedClz[index].checked) {
        //全选
        this.selectedStu[index] = [];
        console.log(this.listStu);

        for (let i = 0; i < this.listStu[index].length; i++) {
          this.selectedStu[index].push(this.listStu[index][i].name);
          s.push(this.listStu[index][i].id);
        }
        this.stuIds = s + "";

        console.log("全选");
        console.log(this.selectedStu[index]);

      } else {
        //全不选
        this.selectedStu[index] = [];
        this.stuIds = "";
        console.log("取消全选");
        console.log(this.selectedStu[index]);

      }
      this.$forceUpdate();
    },
    //打开弹框
    open(parameter, title, disabled, size) {
      // title    编辑/添加
      this.examId = "";
      this.examIds = [];
      this.listStu = []
      this.selectedStu = [];
      this.selectedClz = [];
      this.clzIdxes = [];
      this.selectedNoexStu = [];
      this.clzIdx = "";
      this.stuIds = ""

      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.stuExamInfo = []
      this.stuExamName = ""
      this.$refs.popup.close();
    },
    //取消提交
    cancle() {
      this.dialogFormVisible = false;
      this.selectedNoexStu = [];
      this.noexamstu = [];
    },
    //提交表单
    confirm() {
      this.formParameter.startTime = this.dateTime[0];
      this.formParameter.endTime = this.dateTime[1];

      if ((!this.formParameter.startTime) || (!this.formParameter.endTime)) {
        this.$utils.confirm.warning("错误", "请填写考试时间");
        return
      }

      let exmType = this.formParameter.type * 1

      //是线下考试/覆盖考试？添加一个exam
      if (exmType == 1 || exmType == 5) {
        //线下考试 ？   去配置试卷

        //必填
        if (exmType == 1 && this.examIds.length == 0) {
          this.$utils.confirm.warning("错误", "线下考试备选试卷必填");
          this.confirmLoading = false;
          return;
        }

        //封装数据 准备传递到下一个组件
        this.formParameter.cid = this.listClass[this.clzIdx];
        this.formParameter.sid = this.selectedStu;

        //open                                      //选择的试卷id
        if (exmType == 1) {
          this.$parent.toAddPaper(this.formParameter, this.examIds);
          //console.log("this.examIds",this.examIds)
        } else {
          //
          this.formParameter.cid = this.selectedClz[0].id

          this.$parent.toAddPaper(this.formParameter);
        }


        //关闭本页
        this.$refs.popup.close();

      } else {

        //验证试卷
        paperApi.toVerify({ id: this.formParameter.expid }, res => {

          this.confirmLoading = true;

          //必填
          if ((!this.formParameter.expid) || this.formParameter.expid.length == 0) {
            this.$utils.confirm.warning("错误", "试卷必填");
            this.confirmLoading = false;
            return;
          }

          //是一个面试考试
          if ((exmType == 2 || exmType == 4) && !this.formParameter.quenum) {
            this.$utils.confirm.warning("错误", "面试考必须要有【题数】");
            this.confirmLoading = false;
            return;
          }

          //轮训面试必须>2倍题数
          if (exmType == 4) {

            examApi.toUpdate({ id: this.formParameter.expid }, res => {
              let content = JSON.parse(res.data.content)
              let countQues = 0
              content.types.forEach((v, i) => {
                countQues += content.qnums[i] * 1
              })
              // console.log("题数countQues = ", countQues)
              if (countQues < this.formParameter.quenum * 2) {
                this.$utils.confirm.warning("错误", "轮训考试卷试题数【" + this.formParameter.quenum + "】需小于试卷考题数【" + countQues + "】的1/2");
                this.confirmLoading = false;
              } else {
                this.addOne()
              }
            });

          } else {
            this.addOne()
          }

        }, err => {
          this.$utils.msg.warning("所选的试卷不完整，缺少部分题目，请转到试卷查看修复。");
        });
      }

    }
    , addOne() {

      //添加考试
      //console.log("this.selectedClz", this.selectedClz)

      this.$confirm("此操作将创建一个新的考试, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        this.formParameter.name = this.stuExamName

        this.selectedClz.forEach((v, i) => {

          let parameter = this.$utils.merger(this.formParameter);
          parameter.cid = v.id;

          if (this.formParameter.type * 1 == 6) {//阶段测评
            parameter.sid = this.selectedNoexStu;
            parameter.sbname = this.subjectInfo[this.selectSubjectIdx].name
          } else {
            parameter.sid = this.selectedStu[i];
          }

          if (this.isMobile) {
            //支持移动端
            //移动端 属于 线上考试
            parameter.type = 0;
            parameter.isMobile = 1;
          }

          console.log("即将保存的数据", parameter);

          api.save(
            parameter,
            (response) => {

              if (i == this.selectedClz.length - 1) {  // the last one
                this.$utils.msg.success(response.msg);
                this.confirmLoading = false;

                this.dialogFormVisible = false;
                this.noexamstu = [];
                this.selectedNoexStu = [];
                this.stuExamName = ""

                this.close();
                this.$parent.list();
              }

            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        });

      }).catch(() => {
        this.confirmLoading = false;
        return;
      });

    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = { canScore: 1, type: 0 };
      this.sbname = "";
      this.dateTime = "";
      //reset
      this.examId = "";
      this.examIds = [];
      this.listStu = [];
      this.selectedStu = [];
      this.selectedClz = [];
      this.clzIdxes = [];
      this.clzIdx = "";
      this.listExam = [];

      this.stuExamName = "";
      //清楚校验
      this.$refs.form.clearValidate();

      classApi.list3({}, (response) => {
        this.listClass = response.data;
      });

      this.tomorrow = new Date(new Date().getTime() + 1000 * 60 * 60 * 24)

      //添加
      this.popupLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
